<template>
  <section class="delete-topic">
    <div>
      When you think you don't need this topic anymore - you can just delete it. This action is <u>irreversible</u>
    </div>
    <yn-button variant="contained" color="primary" title="Delete this topic" @click="remove()"
      >Delete &times;</yn-button
    >
  </section>
</template>

<script>
import Button from '@/components/common/Button';

export default {
  components: {
    'yn-button': Button
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },

  methods: {
    async remove() {
      const confirmResult = await this.$confirm({
        title: 'Delete topic?',
        message: `Are you sure you want to delete this topic? This action can't be undone.`,
        confirm: 'Delete'
      });

      if (!confirmResult) {
        return;
      }

      const lock = this.$lock();
      try {
        await this.$store.dispatch('topics/delete', { id: this.id });

        this.$toast.success({
          title: 'Delete completed',
          message: `Topic '${this.id}' was deleted.`
        });
        this.$router.push({ path: `/` });
      } catch (e) {
        this.$toast.error({
          title: 'Delete failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.delete-topic {
  > div {
    margin-bottom: 1rem;
  }
}
</style>
